import { __decorate } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Widget } from "@shop-builder/core/widget";
import MonthlyTariffPriceBox from "@shop-builder/shared/MonthlyTariffPriceBox";
import DeviceOneTimePriceBox from "@shop-builder/shared/DeviceOneTimePriceBox";
import { Configurator } from "../../../api/services/configurator";
import { findOneById } from "../../../api/services/products";
import { KissDeviceDetailColor } from "@shop-builder/widgets/kiss-device-detail/kiss-device-detail-color";
import { KissDeviceDetailCapacity } from "@shop-builder/widgets/kiss-device-detail/kiss-device-detail-capacity";
import { getWidget, preloadImages, scrollTo } from "@api/utils";
var KissDeviceDetailWidget = /*@__PURE__*/ (function () {
    function KissDeviceDetailWidget() {
        this.currentSlideIndex = 0;
        this.deviceOneTimePriceBoxes = [];
        this.tariffMonthlyPriceBoxes = [];
        this.colorComponents = [];
        this.capacityComponents = [];
        this.activeColor = null;
        this.activeCapacity = null;
        this.productImageWrapper = document.querySelector(".mod-ep-kiss-device-detail__product-image-wrapper");
        this.currentImages = "";
        this.checkboxSelector = ".option-checkbox__checkbox";
        this.labelSelector = ".option-checkbox__label";
        this.optionItemSelector = ".option-checkbox";
    }
    KissDeviceDetailWidget.prototype.didMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var DeviceOneTimePriceBoxContainers, TariffPriceBoxContainers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        DeviceOneTimePriceBoxContainers = Array.prototype.slice.call(document.querySelectorAll(".mod-ep-kiss-device-detail__tariff-monthly-price-box-container"));
                        return [4 /*yield*/, DeviceOneTimePriceBoxContainers.forEach(function (container) {
                                return _this.deviceOneTimePriceBoxes.push(new DeviceOneTimePriceBox(container));
                            })];
                    case 1:
                        _a.sent();
                        TariffPriceBoxContainers = Array.prototype.slice.call(document.querySelectorAll(".mod-ep-kiss-device-detail__device-one-time-price-box-container"));
                        return [4 /*yield*/, TariffPriceBoxContainers.forEach(function (container) {
                                return _this.tariffMonthlyPriceBoxes.push(new MonthlyTariffPriceBox(container));
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadProduct()];
                    case 3:
                        _a.sent();
                        this.setUp();
                        Configurator.subscribe("offerChanged", this.onOfferChanged.bind(this));
                        this.onOfferChanged();
                        this.registerEventListeners();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.registerEventListeners = function () {
        this.getElement()
            .querySelector(".mod-ep-kiss-device-detail__device-details-link")
            .addEventListener("click", function (e) {
            e.preventDefault();
            var widget = getWidget("kiss-device-detail-tabs");
            if (widget) {
                scrollTo("kiss-device-detail-tabs");
            }
        });
    };
    KissDeviceDetailWidget.prototype.onOfferChanged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Configurator.getProduct()];
                    case 1:
                        product = _a.sent();
                        this.product = product;
                        this.setColorActive(product.getCurrentColor());
                        this.setCapacityActive(product.getCurrentCapacity());
                        this.setSelectedOptionsActive();
                        this.setPreview();
                        this.setDeliveryTime();
                        this.updateCoPaymentToggle();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.loadProduct = function () {
        return __awaiter(this, void 0, void 0, function () {
            var product, deviceId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Configurator.getProduct()];
                    case 1:
                        product = _a.sent();
                        this.product = product;
                        deviceId = 0;
                        if (product) {
                            deviceId = product.getId();
                        }
                        if (!(this.getElement().dataset.device &&
                            !Configurator.hasExternalProduct()))
                            return [3 /*break*/, 4];
                        if (!(this.getElement().dataset.device.length > 0))
                            return [3 /*break*/, 4];
                        deviceId = parseInt(this.getElement().dataset.device, 10);
                        return [4 /*yield*/, findOneById(deviceId)];
                    case 2:
                        product = _a.sent();
                        return [4 /*yield*/, Configurator.setProduct(product)];
                    case 3:
                        _a.sent();
                        this.product = product;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.setUp = function () {
        var colorCapacitiesCodes = this.product.getAvailableCapacitiesForColors();
        this.availableCapacitiesForColor = colorCapacitiesCodes[0];
        this.colorCodes = colorCapacitiesCodes[1];
        // Colors
        var colors = this.product
            .getAllColors()
            .map(function (colorString) { return +colorString.split(" ")[0]; });
        this.setUpColors();
        // Capacities
        var capacities = this.product.getAllCapacities();
        this.setUpCapacities(capacities);
        this.setUpCoPaymentToggleClick();
        // this.initProductSlider();
        this.setPreview();
        this.setUpDeviceOptions();
        this.addLoaded();
    };
    KissDeviceDetailWidget.prototype.initProductSlider = function () {
        // Init large image slider / fade
        jQuery(".mod-ep-kiss-device-detail__product-image").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            asNavFor: ".mod-ep-kiss-device-detail__product-thumbnails",
            draggable: true,
            lazyLoad: "ondemand",
            infinite: true,
        });
        // Init thumbnail slider
        jQuery(".mod-ep-kiss-device-detail__product-thumbnails").slick({
            slidesToScroll: 1,
            slidesToShow: 3,
            arrows: true,
            dots: false,
            asNavFor: ".mod-ep-kiss-device-detail__product-image",
            focusOnSelect: true,
            lazyLoad: "ondemand",
            infinite: true,
            prevArrow: '<button class="slide-arrow prev-arrow"><svg><use xlink:href="/simplicity/svgdefs.svg#i-arrow-left-light-sml"></use></svg></button>',
            nextArrow: '<button class="slide-arrow next-arrow"><svg><use xlink:href="/simplicity/svgdefs.svg#i-arrow-right-light-sml"></use></svg></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 9,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                    },
                },
            ],
        });
    };
    KissDeviceDetailWidget.prototype.setUpColors = function () {
        var _this = this;
        var preview = this.getElement().querySelector(".mod-ep-kiss-device-detail__color-choices");
        Object.keys(this.availableCapacitiesForColor).forEach(function (color) {
            var rgbCode = _this.colorCodes[color];
            var colorComponent = new KissDeviceDetailColor("rgb(" + rgbCode + ")", color, _this.handleColorChange.bind(_this));
            _this.colorComponents.push(colorComponent);
            preview.appendChild(colorComponent.render());
        });
    };
    KissDeviceDetailWidget.prototype.setUpCapacities = function (availableCapacitiesTotal) {
        var _this = this;
        var preview = this.getElement().querySelector(".mod-ep-kiss-device-detail__capacity-choices");
        availableCapacitiesTotal.forEach(function (capacity) {
            var capacityValue = parseInt(capacity.split(" ")[0]);
            var capacityUnit = capacity.split(" ")[1];
            var capacityComponent = new KissDeviceDetailCapacity(capacityValue, capacity, _this.handleCapacityChange.bind(_this), capacityUnit);
            _this.capacityComponents.push(capacityComponent);
            preview.appendChild(capacityComponent.render());
        });
    };
    KissDeviceDetailWidget.prototype.handleColorChange = function (activeColor) {
        return __awaiter(this, void 0, void 0, function () {
            var capacitySelected, unit, availableCapacities, isAvailable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.product.selectColor(activeColor.getLabel())];
                    case 1:
                        _a.sent();
                        capacitySelected = this.product
                            .getCurrentCapacity()
                            .toString()
                            .split(" ")[0];
                        unit = this.product.getCurrentCapacity().toString().split(" ")[1];
                        availableCapacities = this.availableCapacitiesForColor[activeColor.getLabel()];
                        isAvailable = availableCapacities.indexOf(+capacitySelected) > -1;
                        if (!!isAvailable)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, this.product.selectCapacity(this.availableCapacitiesForColor[activeColor.getLabel()][0] +
                                " " +
                                unit)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.setDeliveryTime = function () {
        var child = this.product.getCurrentVersion();
        var deliveryTime = child.additional.deliveryTime;
        this.getElement().querySelector(".delivery-time").innerHTML =
            deliveryTime;
    };
    KissDeviceDetailWidget.prototype.setColorActive = function (color) {
        var activeColor = this.colorComponents.find(function (comp) { return comp.getLabel() == color; });
        this.activeColor = activeColor;
        this.colorComponents.forEach(function (color) { return color.setSelected(false); });
        this.activeColor.setSelected(true);
        this.getElement().querySelector(".mod-ep-kiss-device-detail__colors-label>span").innerHTML = this.activeColor.getLabel();
    };
    KissDeviceDetailWidget.prototype.handleCapacityChange = function (activeOption) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.product.selectCapacity(activeOption.getLabel())];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.setCapacityActive = function (capacity) {
        var _this = this;
        var index = this.capacityComponents.findIndex(function (comp) {
            return _this.availableCapacitiesForColor[_this.activeColor.getLabel()][0] == capacity;
        });
        var activeOption = this.capacityComponents.reduce(function (acc, current, index) {
            return current.getLabel().indexOf(capacity) > -1
                ? current
                : acc;
        }, this.capacityComponents[index]);
        this.activeCapacity = activeOption;
        this.capacityComponents.forEach(function (capacity) {
            return capacity.setSelected(false);
        });
        this.disableCapacities(this.availableCapacitiesForColor[this.activeColor.getLabel()]);
        this.activeCapacity.setSelected(true);
        this.getElement().querySelector(".mod-ep-kiss-device-detail__capacities-label>span").innerHTML = this.activeCapacity.getLabel();
    };
    KissDeviceDetailWidget.prototype.disableCapacities = function (capacities) {
        this.capacityComponents.forEach(function (comp) {
            comp.setDisabled(!(capacities.indexOf(+comp.getValue()) > -1));
        });
    };
    KissDeviceDetailWidget.prototype.setPreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var images, preview, thumbnails, _i, images_1, url, productImage, thumbImage, productImageWrap, thumbnailWrap;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.product.getShowcaseImages()];
                    case 1:
                        images = _a.sent();
                        if (images.length === 0) {
                            images = [
                                "https://eweb8.vfd2-testnet.de" + this.product.getImages().large,
                            ];
                        }
                        if (this.currentImages === JSON.stringify(images)) {
                            return [2 /*return*/];
                        }
                        else {
                            this.currentImages = JSON.stringify(images);
                        }
                        preview = document.createElement("div");
                        preview.innerHTML = "";
                        preview.classList.add("mod-ep-kiss-device-detail__product-image");
                        thumbnails = document.createElement("div");
                        thumbnails.innerHTML = "";
                        thumbnails.classList.add("mod-ep-kiss-device-detail__product-thumbnails");
                        //preview.style.opacity = '0';
                        //preview.style.display = 'none';
                        return [4 /*yield*/, preloadImages(images)];
                    case 2:
                        //preview.style.opacity = '0';
                        //preview.style.display = 'none';
                        _a.sent();
                        for (_i = 0, images_1 = images; _i < images_1.length; _i++) {
                            url = images_1[_i];
                            productImage = document.createElement("img");
                            productImage.setAttribute("src", url);
                            thumbImage = productImage.cloneNode(true);
                            productImageWrap = document.createElement("div");
                            productImageWrap.appendChild(productImage);
                            thumbnailWrap = document.createElement("div");
                            thumbnailWrap.classList.add("mod-ep-kiss-device-detail__product-thumb");
                            thumbnailWrap.appendChild(thumbImage);
                            // APPEND WRAPPED IMAGES
                            preview.appendChild(productImageWrap);
                            thumbnails.appendChild(thumbnailWrap);
                        }
                        this.productImageWrapper.innerHTML = "";
                        this.productImageWrapper.appendChild(preview);
                        this.productImageWrapper.appendChild(thumbnails);
                        this.initProductSlider();
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.setSelectedOptionsActive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var labelElements, offer, usedOptions;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        labelElements = Array.prototype.slice.call(this.getElement().querySelectorAll(this.labelSelector));
                        labelElements.forEach(function (el) {
                            el.classList.remove("checked");
                        });
                        return [4 /*yield*/, Configurator.getOffer()];
                    case 1:
                        offer = _a.sent();
                        usedOptions = offer.getUsedOptions();
                        usedOptions.forEach(function (option) {
                            var optionElement = _this.getElement().querySelector(".mod-ep-kiss-device-detail #option-with-id-" + option.id);
                            // there might be more options than we have available here
                            if (optionElement) {
                                optionElement = optionElement.querySelector("label");
                                optionElement.classList.add("checked");
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.handleOptionClicked = function (optionalService) {
        return __awaiter(this, void 0, void 0, function () {
            var offer, usedOptions, isChecked;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Configurator.getOffer()];
                    case 1:
                        offer = _a.sent();
                        usedOptions = offer.getUsedOptions();
                        isChecked = usedOptions.map(function (used) { return used.id; }).indexOf(optionalService.id) > -1;
                        if (!isChecked)
                            return [3 /*break*/, 3];
                        return [4 /*yield*/, offer.cancelOption(optionalService)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, offer.useOption(optionalService)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    KissDeviceDetailWidget.prototype.updateCoPaymentToggle = function () {
        var toggleContainer = this.getElement().querySelector(".mod-ep-kiss-device-detail__copayment-chooser-container");
        if (toggleContainer) {
            var coPaymentState = Configurator.getCoPaymentState();
            // coPaymentState === CoPaymentState.TOGGLE_ON && console.log("Toggle On");
            toggleContainer.style.display =
                coPaymentState === 0 /* NON_EXISTENT */ ||
                    coPaymentState === 3 /* NON_EXISTENT_OFF */
                    ? "none"
                    : "inline-flex";
            var toggle = toggleContainer.getElementsByClassName("ep-shop-toggle-switch__checkbox")[0];
            if (coPaymentState === 2 /* TOGGLE_OFF */) {
                toggle.checked = false;
            }
            else if (1 /* TOGGLE_ON */) {
                toggle.checked = true;
            }
        }
    };
    KissDeviceDetailWidget.prototype.setUpCoPaymentToggleClick = function () {
        var _this = this;
        var toggleInput = this.getElement().getElementsByClassName("ep-shop-toggle-switch__checkbox")[0];
        if (toggleInput) {
            toggleInput.addEventListener("click", function () {
                return _this.handleCoPaymentToggleClick(toggleInput);
            });
        }
    };
    KissDeviceDetailWidget.prototype.handleCoPaymentToggleClick = function (toggle) {
        return __awaiter(this, void 0, void 0, function () {
            var coPaymentState;
            return __generator(this, function (_a) {
                coPaymentState = Configurator.getCoPaymentState();
                if (coPaymentState == 2 /* TOGGLE_OFF */) {
                    Configurator.setCoPaymentState(1 /* TOGGLE_ON */);
                }
                else {
                    Configurator.setCoPaymentState(2 /* TOGGLE_OFF */);
                }
                return [2 /*return*/];
            });
        });
    };
    KissDeviceDetailWidget.prototype.setUpDeviceOptions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var availableOptions, availableIds, optionIds;
            var _this = this;
            return __generator(this, function (_a) {
                availableOptions = Configurator.getOffer().optionalServices[0].items;
                availableIds = availableOptions.map(function (item) { return item.id; });
                optionIds = (Array.prototype.slice.call(this.getElement().querySelectorAll(this.optionItemSelector)));
                optionIds.forEach(function (el) {
                    var index = availableIds.indexOf(+el.dataset.optionId);
                    if (index > -1) {
                        var labelElement = (el.querySelector(_this.labelSelector));
                        var checkboxElement = (el.querySelector(_this.checkboxSelector));
                        checkboxElement.addEventListener("click", function () {
                            _this.handleOptionClicked(availableOptions[index]);
                        });
                    }
                    else {
                        el.style.display = "none";
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    KissDeviceDetailWidget.prototype.addLoaded = function () {
        jQuery(".mod-ep-kiss-device-detail").addClass("loaded");
    };
    KissDeviceDetailWidget = __decorate([
        Widget({
            name: "kiss-device-detail",
        })
    ], KissDeviceDetailWidget);
    return KissDeviceDetailWidget;
}());
export { KissDeviceDetailWidget };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-device-detail/kiss-device-detail.ts
// module id = null
// module chunks = 